<template>
    <div role="dialog" :class="{'modal':true,'fade':effect === 'fade','zoom':effect === 'zoom'}" v-if="type == 'alert'">
        <div :class="{'modal-dialog':true,'modal-sm':true}" role="document" :style="{width: optionalWidth,top:'800px'}">
            <div class="modal-content">
                <slot name="modal-header">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            {{title}}
                        </h4>
                    </div>
                </slot>
                <slot name="modal-body">
                    <div class="modal-body">
                        <p>{{message}}</p>
                    </div>
                </slot>
                <slot name="modal-footer">
                    <div class="modal-footer">
                        <ob-button type="primary" v-if="confirmButtonText"  @click="handleConfirmAction">{{confirmButtonText}}</ob-button>
                    </div>
                </slot>
            </div>
        </div>
    </div>
    <ob-modal2 :backdrop="false" :show.sync="show" :type="1" v-else-if="type == 'confirm'">
        <div class="modal--body">
            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/icons/info_red_icon.svg`" style="width:45px;" />
            <h1 v-if="title && title != ''">{{title}}</h1>
            <p v-if="message && message != ''">{{message}}</p>
        </div>

        <div class="modal--footer">
            <ob-button type="primary" @click="handleYesAction">{{yesButtonText && yesButtonText != '' ? yesButtonText : 'Yes'}}</ob-button>
            <ob-button type="secondary" @click="handleNoAction">{{noButtonText && noButtonText != '' ? noButtonText : 'No'}}</ob-button>
        </div>
    </ob-modal2>
    <ob-modal2 :backdrop="false" :show.sync="show" :type="1" v-else-if="type == 'confirmWithRadio'">
        <div class="modal--body">
            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/icons/warning.svg`" style="width:45px;" />
            <h1 v-if="title && title != ''" style="margin-bottom: 30px; color: #F3A432; font-weight: 400;">{{title}}</h1>
            <div  style="margin-bottom: 30px;color: #123262;font-size: 14px;" v-if="message && message != ''" v-html="message"></div>
            <ob-checkbox v-model="termsCheckBox">{{termsContent}}</ob-checkbox>
        </div>

        <div class="modal--footer">
            <ob-button type="secondary" @click="handleNoAction">{{noButtonText && noButtonText != '' ? noButtonText : 'No'}}</ob-button>
            <ob-button :disabled="!termsCheckBox" type="primary" @click="handleYesAction">{{yesButtonText && yesButtonText != '' ? yesButtonText : 'Yes'}}</ob-button>
        </div>
    </ob-modal2>
</template>

<script>
    import jquery from 'jquery'

    export default {
        data() {
            return {
                show: false,
                message: '',
                width: 500,
                effect: 'zoom',
                type:'alert',

                confirmButtonText:'Ok',
                title:'',
                mesgObj:'',
                callback:'',
                termsContent: '',
                termsCheckBox: false,

                // For Confirm
                yesButtonText: 'Yes',
                noButtonText: 'No'
            }
        },
        computed: {
            optionalWidth () {
                if (this.width === null) {
                    return null
                } else if (Number.isInteger(this.width)) {
                    return this.width + 'px'
                }
                return this.width
            }
        },
        watch: {
            show (val) {
                const el = this.$el
                const body = document.body
                //const scrollBarWidth = getScrollBarWidth()
                if (val) {
                    jquery(el).find('.modal-content').focus()
                    el.style.display = 'block'
                    setTimeout(() => jquery(el).addClass('in'), 0)
                    jquery(body).addClass('vue-modal-open')

                    if (this.backdrop) {
                        jquery(el).on('click', e => {
                            if (e.target === el) {
                                this.close()
                            }
                        })
                    }


                } else {
                    body.style.paddingRight = null
                    jquery(body).removeClass('vue-modal-open')
                    jquery(el).removeClass('in').on('transitionend', () => {
                        $(el).off('click transitionend')
                        el.style.display = 'none'
                    })

                    this.destroyElement()
                }
            }
        },

        methods: {
            destroyElement() {
                //this.$el.removeEventListener('transitionend', this.destroyElement);
                if(this.$el.parentNode) {
                    this.$destroy(true);
                    this.$el.parentNode.removeChild(this.$el);
                }
            },
            handleConfirmAction(){
                this.show = false;
                if(this.callback != ''){
                    this.callback()
                }
            },
            handleYesAction() {
                this.show = false;
                if(this.callback){
                    this.callback(true)
                }
            },
            handleNoAction() {
                this.show = false;
                if(this.callback){
                    this.callback(false)
                }
            }
        },
        mounted() {
            this.show = true
            if(this.mesgObj != ''){
                if(this.mesgObj.confirmButtonText) {
                    this.confirmButtonText = this.mesgObj.confirmButtonText;
                }
                else {
                    this.confirmButtonText = 'Ok'
                }
                this.type = this.mesgObj.type

                if(this.mesgObj.callback) {
                    this.callback = this.mesgObj.callback
                }

                // For confirm
                if(this.mesgObj.yesButtonText) {
                    this.yesButtonText = this.mesgObj.yesButtonText
                }

                if(this.mesgObj.noButtonText) {
                    this.noButtonText = this.mesgObj.noButtonText
                }


                if(this.mesgObj.termsContent) {
                    this.termsContent = this.mesgObj.termsContent
                }

            }
        }
    }
</script>

<style lang="scss" scoped>

     @import "~styles/framework/vue-utils";

    @import "~styles/framework/bootstrap/modals";

.modal {
  transition: all 0.3s ease;
}
.modal.in {
  background-color: rgba(0,0,0,0.5);
}
.modal.zoom .modal-dialog {
  transform: scale(0.1);
  top: 600px;
  opacity: 0;
  transition: all 0.3s;
}
.modal.zoom.in .modal-dialog {
  transform: scale(1);
  transform: translate3d(0, -600px, 0);
  opacity: 1;
}

/*popup styles*/
.modal--body {
    text-align: center;
    padding: 25px;
}

.modal--footer {
    text-align: center;
    padding: 0px 15px 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/MovedFromVueStyleGuide/MessageBox/MessageBox.vue